import React, { createContext, useState } from 'react';
import { MaterialBranch, Task} from '../models/dashboard-models';
import { BranchDevice, InventoryContent } from '../models/warehouse-models';
import { getTaskById } from '../utils/work-hooks';

interface TasksContextProps {
    selectedTask: Task | undefined;
    setSelectedTask: React.Dispatch<React.SetStateAction<Task | undefined>>;
    taskDevices: BranchDevice[];    
    setTaskDevices: React.Dispatch<React.SetStateAction<BranchDevice[]>>;
    materials: MaterialBranch[] | undefined;
    setMaterials: React.Dispatch<React.SetStateAction<MaterialBranch[] | undefined>>;
    usedItems: InventoryContent[];
    setUsedItems: React.Dispatch<React.SetStateAction<InventoryContent[]>>;
    refetchTask: (taskId: number) => void;
    attachBatchNumbersToDevices: () => void;
}

export const TasksContext = createContext({} as TasksContextProps);

export const TasksProvider: React.FC = ({ children }) => {
    const [selectedTask, setSelectedTask] = useState<Task>();
    const [usedItems, setUsedItems] = useState<InventoryContent[]>([]);
    const [taskDevices, setTaskDevices] = useState<BranchDevice[]>([]);
    const [materials, setMaterials] = useState<MaterialBranch[] | undefined>();

    const refetchTask = async (taskId: number) => {
        const task = await getTaskById(taskId);
        setSelectedTask(task);
        setMaterials(task.materials);
    };

    const attachBatchNumbersToDevices = () => {
        let usedItemsCopy: InventoryContent[] = [...usedItems];
        setTaskDevices((prevState) => {
            return prevState.map((device) => {
                const usedDevice = usedItems.find((item) => item.idOfPassport === device.passportId);
                if (usedDevice === undefined) return device;
                if (usedDevice.count <= 1) usedItemsCopy = usedItemsCopy.filter((value) => value === usedDevice);
                else
                    usedItemsCopy = usedItemsCopy.map((value) => {
                        if (value !== usedDevice) return value;
                        return { ...value, count: usedDevice.count - 1 };
                    });
                return { ...device, batchNumber: usedDevice.batchCode };
            });
        });
    };

    return (
        <TasksContext.Provider
            value={{
                selectedTask,
                setSelectedTask,
                taskDevices,
                setTaskDevices,
                materials,
                setMaterials,
                refetchTask,
                usedItems,
                setUsedItems,
                attachBatchNumbersToDevices,
            }}
        >
            {children}
        </TasksContext.Provider>
    );
};
